import { render, staticRenderFns } from "./SideBarModalComponent.vue?vue&type=template&id=27c2a1a0&scoped=true"
import script from "./SideBarModalComponent.vue?vue&type=script&lang=js"
export * from "./SideBarModalComponent.vue?vue&type=script&lang=js"
import style0 from "./SideBarModalComponent.vue?vue&type=style&index=0&id=27c2a1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2a1a0",
  null
  
)

export default component.exports